// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toolbar superior */
.cal-toolbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 8px;
}

.cal-nav {
  display: flex;
  gap: 8px;
  align-items: center;
}

.cal-header-title {
  font-weight: 700;
  font-size: 1.35rem;
  text-transform: capitalize;
  text-align: center;
}

.cal-filters {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
}

/* Calendari */
.cal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
}

.cal-dow {
  font-weight: 600;
  text-align: center;
  padding: 4px 0;
}

.cal-cell {
  border: 1px solid #ddd;
  border-radius: 8px;
  min-height: 92px;
  padding: 6px;
  position: relative;
  background: #fff;
  -webkit-user-select: none;
          user-select: none;
}

.cal-dim { opacity: 0.45; }
.cal-sel { outline: 2px solid var(--dash-accent, #3b82f6); }

.cal-daynum {
  font-size: 0.9rem;
  font-weight: 700;
}

.cal-pills {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cal-pill {
  font-size: 0.78rem;
  padding: 2px 6px;
  border-radius: 999px;
  background: #f2f2f2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default; /* doble-clic per editar */
}

.cal-pill-pendent { background: #fff3cd; }
.cal-pill-encurs { background: #d1ecf1; }
.cal-pill-finalitzat { background: #d4edda; }
.cal-pill-rebutjat { background: #f8d7da; }

.cal-pill-avis {
  border-left: 4px solid #FF9933;
}

.cal-pill-tasca {
  border-left: 4px solid #0099CC;
}

.cal-tipus-filtres {
  display: flex;
  gap: 6px;
  align-items: center;
}

.cal-tipus-filtres .Agenda-badge,
.Agenda-resum-comptadors .Agenda-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
  color: #fff;
}

.cal-tipus-filtres .Agenda-badge-avis { background-color: #FF9933; }
.cal-tipus-filtres .Agenda-badge-tasca { background-color: #0099CC; }

.cal-tipus-filtres button.Agenda-badge {
  cursor: pointer;
  border: 2px solid transparent;
}

.cal-tipus-filtres button.Agenda-badge.Agenda-badge-inactiu {
  background-color: #fff;
  color: #666;
}

.cal-tipus-filtres button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-avis {
  border-color: #FF9933;
  color: #c46a10;
}

.cal-tipus-filtres button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-tasca {
  border-color: #0099CC;
  color: #007399;
}

.cal-more {
  font-size: 0.75rem;
  opacity: 0.7;
}

.cal-day-title {
  font-weight: 600;
  margin-bottom: 6px;
}

.cal-vista-selector {
  display: flex;
  gap: 6px;
}

.cal-any-graella {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.cal-mes-bloc-petit {
  background: var(--dv2-surface, #fff);
  border: 1px solid var(--dv2-border, #ddd);
  border-radius: var(--dv2-radius, 8px);
  padding: 10px;
}

.cal-mes-titol {
  font-weight: 700;
  text-align: center;
  margin-bottom: 6px;
  font-size: 13px;
}

.cal-mes-bloc-petit .cal-grid {
  gap: 2px;
}

.cal-mes-bloc-petit .cal-dow {
  font-size: 11px;
  padding: 2px 0;
}

.cal-cell-petit {
  min-height: 36px;
  padding: 2px;
}

.cal-cell-petit .cal-daynum {
  font-size: 12px;
}

.cal-cell-buit {
  min-height: 36px;
  border: none;
  background: transparent;
}

.cal-dots {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 2px;
}

.cal-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.cal-dot-avis {
  background: #FF9933;
}

.cal-dot-tasca {
  background: #0099CC;
}

.dv2-filterBar.cal-toolbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: end;
}

/* Modal */
.cal-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
}

.cal-modal-content {
  background: #fff;
  width: min(980px, 96vw);
  max-height: 90vh;
  overflow: auto;
  border-radius: 10px;
  padding: 8px 16px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/calendariagenda.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,WAAW,aAAa,EAAE;AAC1B,WAAW,8CAA8C,EAAE;;AAE3D;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe,EAAE,0BAA0B;AAC7C;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,mBAAmB,mBAAmB,EAAE;AACxC,uBAAuB,mBAAmB,EAAE;AAC5C,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA,wCAAwC,yBAAyB,EAAE;AACnE,yCAAyC,yBAAyB,EAAE;;AAEpE;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":["/* Toolbar superior */\r\n.cal-toolbar {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.cal-nav {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.cal-header-title {\r\n  font-weight: 700;\r\n  font-size: 1.35rem;\r\n  text-transform: capitalize;\r\n  text-align: center;\r\n}\r\n\r\n.cal-filters {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n/* Calendari */\r\n.cal-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 6px;\r\n}\r\n\r\n.cal-dow {\r\n  font-weight: 600;\r\n  text-align: center;\r\n  padding: 4px 0;\r\n}\r\n\r\n.cal-cell {\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  min-height: 92px;\r\n  padding: 6px;\r\n  position: relative;\r\n  background: #fff;\r\n  user-select: none;\r\n}\r\n\r\n.cal-dim { opacity: 0.45; }\r\n.cal-sel { outline: 2px solid var(--dash-accent, #3b82f6); }\r\n\r\n.cal-daynum {\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.cal-pills {\r\n  margin-top: 6px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.cal-pill {\r\n  font-size: 0.78rem;\r\n  padding: 2px 6px;\r\n  border-radius: 999px;\r\n  background: #f2f2f2;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  cursor: default; /* doble-clic per editar */\r\n}\r\n\r\n.cal-pill-pendent { background: #fff3cd; }\r\n.cal-pill-encurs { background: #d1ecf1; }\r\n.cal-pill-finalitzat { background: #d4edda; }\r\n.cal-pill-rebutjat { background: #f8d7da; }\r\n\r\n.cal-pill-avis {\r\n  border-left: 4px solid #FF9933;\r\n}\r\n\r\n.cal-pill-tasca {\r\n  border-left: 4px solid #0099CC;\r\n}\r\n\r\n.cal-tipus-filtres {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.cal-tipus-filtres .Agenda-badge,\r\n.Agenda-resum-comptadors .Agenda-badge {\r\n  display: inline-block;\r\n  padding: 2px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1.6;\r\n  white-space: nowrap;\r\n  color: #fff;\r\n}\r\n\r\n.cal-tipus-filtres .Agenda-badge-avis { background-color: #FF9933; }\r\n.cal-tipus-filtres .Agenda-badge-tasca { background-color: #0099CC; }\r\n\r\n.cal-tipus-filtres button.Agenda-badge {\r\n  cursor: pointer;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n.cal-tipus-filtres button.Agenda-badge.Agenda-badge-inactiu {\r\n  background-color: #fff;\r\n  color: #666;\r\n}\r\n\r\n.cal-tipus-filtres button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-avis {\r\n  border-color: #FF9933;\r\n  color: #c46a10;\r\n}\r\n\r\n.cal-tipus-filtres button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-tasca {\r\n  border-color: #0099CC;\r\n  color: #007399;\r\n}\r\n\r\n.cal-more {\r\n  font-size: 0.75rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n.cal-day-title {\r\n  font-weight: 600;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.cal-vista-selector {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.cal-any-graella {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.cal-mes-bloc-petit {\r\n  background: var(--dv2-surface, #fff);\r\n  border: 1px solid var(--dv2-border, #ddd);\r\n  border-radius: var(--dv2-radius, 8px);\r\n  padding: 10px;\r\n}\r\n\r\n.cal-mes-titol {\r\n  font-weight: 700;\r\n  text-align: center;\r\n  margin-bottom: 6px;\r\n  font-size: 13px;\r\n}\r\n\r\n.cal-mes-bloc-petit .cal-grid {\r\n  gap: 2px;\r\n}\r\n\r\n.cal-mes-bloc-petit .cal-dow {\r\n  font-size: 11px;\r\n  padding: 2px 0;\r\n}\r\n\r\n.cal-cell-petit {\r\n  min-height: 36px;\r\n  padding: 2px;\r\n}\r\n\r\n.cal-cell-petit .cal-daynum {\r\n  font-size: 12px;\r\n}\r\n\r\n.cal-cell-buit {\r\n  min-height: 36px;\r\n  border: none;\r\n  background: transparent;\r\n}\r\n\r\n.cal-dots {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 2px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.cal-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.cal-dot-avis {\r\n  background: #FF9933;\r\n}\r\n\r\n.cal-dot-tasca {\r\n  background: #0099CC;\r\n}\r\n\r\n.dv2-filterBar.cal-toolbar {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  align-items: end;\r\n}\r\n\r\n/* Modal */\r\n.cal-modal {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,.25);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 50;\r\n}\r\n\r\n.cal-modal-content {\r\n  background: #fff;\r\n  width: min(980px, 96vw);\r\n  max-height: 90vh;\r\n  overflow: auto;\r\n  border-radius: 10px;\r\n  padding: 8px 16px 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
